import store from '../store'
import { eventBus } from '../components/js/eventBus.js'

const DEFAULT_TITLE = 'SysClass - Seu Sistema de Planejamento Acadêmico';

// Rotas que usam sincronização de filtros via URL
const FILTER_SYNC_ROUTES = [
    'vacancy-control',
    'roomAllocation',
    'roomLink',
    'ambience-occupation',
    'allocation'
]

// EP-958, Task 10 — rotas que continuam acessíveis mesmo quando o
// usuário está bloqueado pela governança. Espelha a allowlist do
// middleware backend (config/governance.php) para evitar que o SPA
// pisque em telas que o backend vai recusar.
const GOVERNANCE_ALLOWLIST = [
    'login',
    'worktime',
    'vacancy-control',
    'ambiences-map',
    'occupancy.dashboard',
    '404',
    '403',
    '500',
    '503',
]

// Rotas que continuam acessíveis mesmo com um bloqueio de menu vigente —
// evita travar login/seleção de período e a própria tela de configuração
// dos bloqueios.
const MENU_BLOCK_ALLOWLIST = [
    'login',
    'worktime',
    'menuAccessBlockIndex',
    '404',
    '403',
    '500',
    '503',
]

export default async (to, from , next) => {
    
    //Definindo título da página
    document.title = to.meta.title ? 'SysClass - ' + to.meta.title : DEFAULT_TITLE;

    eventBus.$emit('in-login', (to.name === 'login' || to.name === 'availability-teacher'));

    // Sincroniza filtros da URL para o store em rotas de ocupação
    if (FILTER_SYNC_ROUTES.some(route => to.name?.includes(route) || to.path?.includes(route))) {
        if (Object.keys(to.query).length > 0) {
            store.dispatch('roomAllocationFilters/syncFromRoute', to.query)
        }
    }
    
    var noAuth = [
        'availability-teacher', 
        'AccountIndex', 
        '404', 
        '403', 
        '500', 
        '503',
        'login', 
        'worktime', 
        'teacher-mail-confirm', 
        'reset_password',
        'confirm_password',
        'access-teacher',
        'login/teacher',
        'teacher/page',
        'teacher-panel',
        'license-expired',
        'term-signature',
        // '/login/anima/redirect',
    ]

    if(noAuth.includes(to.name) || noAuth.includes(to.path)){
        next();
        return;
    }

    if(to.name !== 'login' && !store.getters['auth/hasToken']){
        try {
            await store.dispatch('auth/ActionCheckToken')
            next({path: to.path, query: to.query})
            return;

        } catch(error) {
            next({name: 'login'})
            return;
        }
    }else if(to.name !== 'login' && to.name !== 'worktime' && !store.getters['auth/hasAcesso']){
        next( { name: 'worktime' } );
        return;
    }else{

        var user = store.getters['auth/user']
        var now = new Date(new Date().toString()).getTime() / 1000;
        var menu = store.getters['auth/menu']

        if(user.expire_in == undefined) {
            await store.dispatch('auth/ActionSignOut')
            next({ name: 'login' })
            return;
        }

        if(now >  user.expire_in) {
            await store.dispatch('auth/ActionSignOut')
            next({ name: 'login' })
            return;
        }
        
        var bAccess = false;

        if(menu && (typeof menu.find === 'function')){
            menu.find((element, key) => {

                if(to.path === element.to) {
                    bAccess = true;
                }else if(element.children) {
                    element.children.find((children, keyChildren) => {
                        if(to.path === children.to) {
                            bAccess = true;
                        }
                    })
                }
            })
        }

        var noMenu = ['profile', 'faq-questions', 'my-tickets', 'dynamic-time-results', 'dynamic-allocation-results', 'arp-records', 'ambiences-map', 'cenario-catalogo-items']

        // EP-958, Task 10 — Hard Lock no SPA antes de bater na API.
        // O backend (middleware EnsureOccupancyCompliance) é a verdade,
        // mas o guard aqui evita que telas pisquem antes do redirect.
        const isBlocked = store.getters['governance/isBlocked']
        if (isBlocked && !GOVERNANCE_ALLOWLIST.includes(to.name)) {
            // O overlay pode ter sido dispensado nesta sessão. Avisa pra
            // que ele reabra mesmo quando o redirect cai na mesma rota
            // atual (vacancy-control → vacancy-control não dispara o
            // watcher de $route.name).
            eventBus.$emit('governance:blocked-nav-attempt', {
                attempted: to.name,
                from: from?.name,
            })
            next({ name: 'vacancy-control' })
            return
        }

        // Bloqueio de acesso a menus (perfil × menu, janela de data/horário).
        // O menu (auth/menu) só é recalculado no próximo login — se a janela
        // começou com a sessão já ativa, `bAccess` acima ainda daria acesso.
        // `blockedRoutes` vem de um cache local (polling leve em segundo
        // plano, ver menuAccessBlock/store), então essa checagem aqui não
        // faz nenhuma chamada de rede por navegação.
        const blockedRoutes = store.getters['menuAccessBlock/blockedRoutes']
        // to.path !== '/' evita loop de redirect no caso (auto-inflingido
        // pelo admin) de alguém incluir o próprio Home no bloqueio.
        if (to.path !== '/' && blockedRoutes.includes(to.path) && !MENU_BLOCK_ALLOWLIST.includes(to.name)) {
            // Redireciona sempre para um destino fixo e seguro (não para
            // `from`) — evita qualquer risco de loop caso a rota anterior
            // também esteja bloqueada.
            eventBus.$emit('menu-access-block:blocked-nav-attempt', {
                attempted: to.name,
                from: from?.name,
            })
            next({ path: '/' })
            return
        }

        if(bAccess || noMenu.includes(to.name)) {
            next();
        } else {
            next({ path: '/404'})
        }
    }
}
